import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-with-tabs',
  templateUrl: './card-with-tabs.component.html',
  styleUrls: ['./card-with-tabs.component.scss']
})
export class CardWithTabsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
